import {labels} from '../../quote-tool/globals/config';
import {idgUrl} from '../../global/apiProxy';
import {garageLocatorData} from '../../quote-tool/modules/garageLocator';
import {apSwitchStep} from '../components/apSwitchStep';
import toolLoader from '../components/toolLoader';
import {validateVin} from '../../quote-tool/modules/vehicleSelector';
import apAnalytics from '../components/apAnalytics';
import analyticsErrors from '../components/analyticsErrors';

const $ = jQuery;
const $appointmentToolContainer = $('#appointment-tool');

/** TEST VIN - use only for testing - VF1KR2H4H44781562 */

/**
 * Vehicle selector data
 * @type {{chassisNumber: string, licensePlate: string, mileage: string, vehicleId: string, marques: string, marqueText: string, model: string, modelText: string, fuelType: string}}
 */
export let vehicleSelectorData = {
    marques: '',
    marqueText: '',
    model: '',
    modelText: '',
    chassisNumber: '',
    licensePlate: '',
    mileage: '',
    vehicleId: '',
    fuelType: '',
    releaseDate: '',
};

/**
 * Vehicle selector module
 */
export function apVehicleSelectorModule() {
    vinModal();
    submitModule();
    removeGarageInfoModal('vehicle-select-contact-modal');

    $('#ap-vehicle-select-vin-checkbox').on('change', function () {
        if ($(this).is(':checked')) {
            toggleGarageInfoModal('vehicle-select-contact-modal');
        }
    });
}

/**
 * VIN modal trigger
 * @param id of the checkbox
 */
export function vinModal(id) {
    const $body = $('body');
    const $modal = $('#vin-info-modal');
    const $modalConfirmBtn = $modal.find('.js-vehicle-select--modal');
    const $info = $('.c-qt-vehicle-select__vin-checkbox-info');

    $info.on('click', function () {
        if (!$modal.hasClass('active')) {
            $modal.addClass('active');
            $body.css('overflow', 'hidden');
        } else {
            $modal.removeClass('active');
            $body.css('overflow', 'auto');
        }
    });

    $modalConfirmBtn.on('click', function (e) {
        if ($modal.hasClass('active')) {
            $modal.removeClass('active');
            $body.css('overflow', 'auto');
        }
    });

    $modal.on('click', function (e) {
        if (e.target === this) {
            $modal.removeClass('active');
            $body.css('overflow', 'auto');
        }
    });
}

/**
 * Validate vehicle selects
 * @param $container
 * @returns {boolean}
 */
function validateApVehicleSelect($container) {
    let valid = true;
    let analyticsErrorTexts = [];

    // Vin
    addErrorStateWithCheckbox($container.find('#vin'), '#ap-vehicle-select-vin-checkbox', 'vin');

    // License plate
    addErrorState($container.find('#license-plate'));

    // Mileage
    addErrorStateWithCheckbox($container.find('#mileage'), '#ap-vehicle-select-mileage-checkbox')

    function addErrorState($element) {
        const $parent = $element.parent();
        const $errorHolder = $element.siblings('.js-ap-vehicle-selector-error-message');

        if (!$element.val()) {
            $parent.addClass('error');
            $errorHolder.text(labels.emptyField);
            valid = false;

            analyticsErrorTexts.push('License plate field can’t be empty');
        } else {
            $parent.removeClass('error');
            $errorHolder.text('');
        }
    }

    function addErrorStateWithCheckbox($element, checkboxId, vin = false) {
        const $parent = $element.parent();
        let id = $element.attr('id');
        const $errorHolder = $element.siblings('.js-ap-vehicle-selector-error-message');
        const $checkbox = $appointmentToolContainer.find(checkboxId);

        if (vin) {
            if (!$element.val()) {
                if (!$parent.hasClass('error')) {
                    $parent.addClass('error');
                    $errorHolder.text(labels.emptyField).show();
                }
                valid = false;

                analyticsErrorTexts.push('VIN field can’t be empty');
            } else if (validateVin($element.val()) === false) {
                if (!$parent.hasClass('error')) {
                    $parent.addClass('error');
                    $errorHolder.text(labels.emptyField).show();
                }
                valid = false;

                analyticsErrorTexts.push('Invalid VIN number');
            }
        } else {
            if (id === 'mileage') {
                if (!$element.val()) {
                    toggleRequiredServicesWithoutKilometers();
                } else {
                    toggleRequiredServicesWithoutKilometers(true);
                }
            }

            if (!$element.val() && !$checkbox.is(':checked')) {
                if (!$parent.hasClass('error')) {
                    $parent.addClass('error');
                    $errorHolder.text(labels.emptyField).show();
                }
                valid = false;

                analyticsErrorTexts.push('Mileage field can’t be empty');
            } else {
                if ($parent.hasClass('error')) {
                    $parent.removeClass('error');
                }
                $errorHolder.text('').hide();
            }
        }
    }

    if (!valid) {
        analyticsErrorTexts = analyticsErrorTexts.join(' | ');
        analyticsErrors('vehicle-info', 2, 'user-error', '', analyticsErrorTexts);
    }

    return valid
}

function toggleRequiredServicesWithoutKilometers(pass = false) {
    const $services = $('.js-service-selector--service[data-require-kilometers="1"]');

    if (pass) {
        $services.removeClass('has-required');
    } else {
        $services.addClass('has-required');
    }
}

/**
 * Submit module
 */
function submitModule() {
    $appointmentToolContainer.on('click', '.js-vehicle-select--submit', function () {
        if (validateApVehicleSelect($appointmentToolContainer)) {
            const $selectVin = $appointmentToolContainer.find('#vin');
            const $selectLicensePlate = $appointmentToolContainer.find('#license-plate');
            const $selectMileage = $appointmentToolContainer.find('#mileage');
            const vinValue = $selectVin.val();

            vehicleSelectorData.chassisNumber = vinValue;
            vehicleSelectorData.licensePlate = $selectLicensePlate.val();
            vehicleSelectorData.mileage = $selectMileage.val();

            if (!$appointmentToolContainer.find('#ap-vehicle-select-vin-checkbox').is(':checked')) {
                toolLoader();
                loadByVin(vinValue);
            } else {
                toggleGarageInfoModal('vehicle-select-contact-modal');
            }
        }
    });
}

/**
 * Load vehicle by VIN number
 * @param vin
 */
function loadByVin(vin) {
    const $vin = $('#vin');
    const settings = {
        async: true,
        url: idgUrl(`vins/${encodeURIComponent(vin)}`),
        method: 'GET',
        headers: {
            Accept: 'application/json',
        },
    };

    $.when($.ajax(settings)).then(function (vehicles, status, jqXHR) {
        if (vehicles.data[0].vehicleId) {
            const vehicleId = vehicles.data[0].vehicleId;
            $vin.siblings('.js-ap-vehicle-selector-error-message').text('').hide();

            vehicleSelectorData.vehicleId = vehicleId;
            loadVehicles(vehicleId);
        }
    }).fail(function (error) {
        if (error) {
            toolLoader(true);
            $vin.parent().addClass('error');
            $vin.siblings('.js-ap-vehicle-selector-error-message').text(labels.notFoundChassisNumber).show();
            analyticsErrors('vehicle-info', 2, 'user-error', '', 'Invalid VIN number');
        }
    });
}

/**
 * Load vehicle data by vehicle ID
 * @param vehiclesId
 */
function loadVehicles(vehiclesId) {
    const settings = {
        async: true,
        url: idgUrl(`vehicles/${encodeURIComponent(vehiclesId)}`),
        method: 'GET',
        headers: {
            Accept: 'application/json',
        },
    };

    $.ajax(settings).done(function (response) {
        if (response) {
            if (response.version.model) {
                vehicleSelectorData.marques = response.version.model.make.id;
                vehicleSelectorData.marqueText = response.version.model.make.label;
                vehicleSelectorData.model = response.version.model.id;
                vehicleSelectorData.modelText = response.version.model.label;
                vehicleSelectorData.fuelType = response.energyType;

                let releaseDate = response.releaseDate;
                if (!releaseDate) {
                    releaseDate = response.serieStartDate;
                }
                releaseDate = formatReleaseDate(releaseDate);
                vehicleSelectorData.releaseDate = releaseDate;

                setModuleData();

                apSwitchStep('service-selector');

                apAnalytics('vehicle-info--submit', vehicleSelectorData.chassisNumber);
                apAnalytics('choose-service--start');
            }
        }
    });

    toolLoader(true);
}

function formatReleaseDate(input) {
    // Split the input to get month and year
    const [month, year] = input.split('/');

    // Create a new date with the first day of the given month and year
    const date = new Date(`20${year}-${month}-01`);

    // Format the date to "YYYY-MM-DD"
    return date.toISOString().split('T')[0];
}

/**
 * Garage info modal
 * @param id of the modal
 */
export function garageInfoModal(id) {
    const $modal = $(`#${id}`);
    const $days = $modal.find('.js-garage-info-modal--day');
    const $phone = $modal.find(`#${id}-phone`);
    $days.show();

    $days.each(function () {
        const $day = $(this);
        const day = $day.data('day');
        const data = garageLocatorData.workingHours[day];

        if (data && data.length > 0) {
            data.forEach((hours, index) => {
                data[index]['open'] = hours['open'].replace(/(\d{2})(\d{2})/, '$1:$2');
                data[index]['close'] = hours['close'].replace(/(\d{2})(\d{2})/, '$1:$2');
            });

            // Create working hours string
            let workingHoursString = '';
            data.forEach((hours, index) => {
                workingHoursString += hours.open + ' - ' + hours.close;
                if (index < data.length - 1) {
                    workingHoursString += ' ';
                }
            });

            // If garage is closed on that day add class to li element
            if (workingHoursString === 'closed') {
                $day.hide();
            }
            // Add working hours to DOM
            $day.find('span:last-child').text(workingHoursString);
        } else {
            $day.hide();
        }
    });

    $phone.text(garageLocatorData.phone);
}

/**
 * Toggle garage info modal
 * @param id
 */
export function toggleGarageInfoModal(id) {
    const $modal = $(`#${id}`);
    const $body = $('body');

    if (!$modal.hasClass('active')) {
        $modal.addClass('active');
        $body.css('overflow', 'hidden');
    } else {
        $modal.removeClass('active');
        $body.css('overflow', 'auto');
    }
}

/**
 * Remove garage info modal
 * @param id
 */
function removeGarageInfoModal(id) {
    const $modal = $(`#${id}`);
    const $body = $('body');

    $modal.on('click', function (e) {
        if (e.target === this) {
            $modal.removeClass('active');
            $body.css('overflow', 'auto');
        }
    });
}

/**
 * Set module data
 */
function setModuleData() {
    const marque = vehicleSelectorData.marqueText;
    const model = vehicleSelectorData.modelText;
    let vehicle;

    if (model.includes(marque)) {
        vehicle = model;
    } else {
        vehicle = `${marque} ${model}`;
    }

    $appointmentToolContainer.find('.js-tool-sidebar--vehicle').text(vehicle);

    if (vehicleSelectorData.licensePlate) {
        $appointmentToolContainer.find('.js-tool-sidebar--licence').text(vehicleSelectorData.licensePlate);
    }

    if (vehicleSelectorData.chassisNumber) {
        $appointmentToolContainer.find('.js-tool-sidebar--vin').text(vehicleSelectorData.chassisNumber);
    }
}
